import React from 'react';
import { func, shape, string, array } from 'prop-types';
import { CloseIcon } from '../icons/closeIcon';
import BodyEnd from '../BodyEnd';

class ProductSearch extends React.Component {
  constructor(props) {
    super(props);
    this.inputref = React.createRef();
    this.inputwrap = React.createRef();
    this.state = {
      productgroups: props.productgroups,
      suggest: [],
      selectedProducts: []
    };
    this.customAutocomplete = this.customAutocomplete.bind(this);
    this.reset = this.reset.bind(this);
  }
  componentDidMount() {
    //this.props.selectEquipment({});
  }

  reset() {
    this.inputref.current.focus();
    this.inputref.current.value = '';
  }

  handleClose = (event) => {
    if (event.target.dataset.gdlItemClick != "gdlItem") {
      this.setState({
        suggest: []
      });
    }

  }

  customAutocomplete() {
    let value = '';
    let productgroups = this.props.productgroups;
    if (this.inputref.current.value) {
      value = this.inputref.current.value.toLowerCase().trim();

    }

    if (value != '' && productgroups) {

      let autocompleteSuggest = [];

     // let products=[{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Articulated Dump Trucks","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":8},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Backhoe Loaders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":10},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Crawler Loaders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":16},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Excavators","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":22},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Motor Graders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":38},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Skid Steers","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":47},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Wheel Loaders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":57},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Worksite Pro Attachments","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":58},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Compact Construction Equipment","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":60},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Compact Excavators","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":61},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Compact Track Loaders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":62},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Tractor Loaders (Construction)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":64},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Scraper Tractors (Construction)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":69},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":null,"displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":94},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":null,"displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":96},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Engines (Off-Highway), Industrial - Sales","displayAssociatedNetworkFlag":true,"distributorExistsFlag":false,"id":18},{"sequenceNumber":10,"displayEnginCategoryFlag":true,"name":"Engines (Off-Highway), Industrial - Service","displayAssociatedNetworkFlag":true,"distributorExistsFlag":false,"id":19},{"sequenceNumber":10,"displayEnginCategoryFlag":true,"name":"Engines (On-Highway), Natural Gas-Service","displayAssociatedNetworkFlag":true,"distributorExistsFlag":false,"id":20},{"sequenceNumber":10,"displayEnginCategoryFlag":true,"name":"Engines, Marine- Sales & Service","displayAssociatedNetworkFlag":true,"distributorExistsFlag":false,"id":21},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Funk Drivetrain Components - Sales","displayAssociatedNetworkFlag":true,"distributorExistsFlag":false,"id":27},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Funk Drivetrain Components - Service","displayAssociatedNetworkFlag":true,"distributorExistsFlag":false,"id":28},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Crawler Dozers (Forestry)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":17},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Swing Machines","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":25},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Forwarders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":26},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Harvesters","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":32},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Knuckleboom Loaders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":36},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Skidders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":49},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Feller Bunchers","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":65},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Bunker/Field Rakes","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":11},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Gator™ Utility Vehicles","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":29},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Golf & Sports Mowing Equipment","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":30},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"ProGator™ and TX Turf Gator Utility Vehicles","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":41},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Tractors - Mid (105-215 engine hp)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":52},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Tractors - Small (45-125 engine hp)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":53},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Tractors - Compact (20-66 engine hp)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":59},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"John Deere sold at Lowe's and The Home Depot (Service Only)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":35},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Riding Mowers & Zero-Turn Mowers","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":43},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Scotts Mowers (Service Only)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":44},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Snow Equipment","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":50},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Walk-Behind Mowers","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":55},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Flail Mowers","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":23},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Flail Shredders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":24},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Harvesting (Grain, Cotton, Sugar)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":33},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Hay & Forage","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":34},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Planting & Seeding","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":40},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Rotary Cutters","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":42},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Scrapers","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":45},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Self-Propelled Sprayers & Nutrient Applicators","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":46},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Tillage","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":51},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Tractors - Large (210-620 engine hp)","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":54},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Tractor Loaders","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":66},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Scraper Tractors","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":68},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Self-Propelled Forage Harvesters","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":70},{"sequenceNumber":10,"displayEnginCategoryFlag":false,"name":"Commercial Mowing Equipment","displayAssociatedNetworkFlag":false,"distributorExistsFlag":false,"id":12}];
       autocompleteSuggest = this.props.productgroups.filter((productgroup) => {
       // autocompleteSuggest = products.filter((productgroup) => {
        return productgroup.name && productgroup.name.toLowerCase().indexOf(value) != -1;
      });
      autocompleteSuggest = autocompleteSuggest.slice(0, 5);
      if (autocompleteSuggest && autocompleteSuggest.length > 0) {
        // document.body.removeEventListener("click",this.handleClose,false);
        document.body.addEventListener("click", this.handleClose, false);
        this.setState({
          suggest: autocompleteSuggest
        });
      }
      else {
        this.setState({
          suggest: autocompleteSuggest
        });
      }
    } else {
      this.setState({
        suggest: []
      });
    }
  }

  deleteSelectedProduct = (id) => {
    let selectedProducts = this.state.selectedProducts.filter((value) => {
      return value.id != id;
    });
    this.setState({
      selectedProducts: selectedProducts
    });
    this.props.selectEquipment({});
  }

  selecteProduct = (product) => {
    if (this.state.selectedProducts.length == 0) {
      this.props.selectEquipment(product);
      this.setState({
        selectedProducts: [...this.state.selectedProducts, product]
      });
    }
    this.setState({
      suggest: []
    });
    this.inputref.current.value = '';
  }

  render() {
    let styles = {};
    if (this.inputwrap != null && this.inputwrap.current != null) {
      let inputwrap = this.inputwrap.current.getBoundingClientRect();

      styles = {
        top: inputwrap.top + inputwrap.height + window.pageYOffset + "px",
        left: inputwrap.left + "px",
        width: inputwrap.width + "px",
        zIndex: 1051

      };
    }
    const {
      translate: {
        GDL_SEARCH_PRODUCTs_EX_MOVER = '',
        GDL_EQUIPMENT = '',
        GDL_NO_PRODUCT_SELECTED = ''
      }
    } = this.props;
    return (
      <div className="product-search" data-test="product-search">
        <h6 className={
            this.props.hidelabel ?
              "hidden" : ""
          }>{GDL_EQUIPMENT}</h6>
        <div
          className={
            this.state.selectedProducts &&
              this.state.selectedProducts.length != 0 ?
              "hidden" : "invalid-product"
          }
        >
          {GDL_NO_PRODUCT_SELECTED}
        </div>
        <div className="gdl-selected-product">
          {
            this.state.selectedProducts &&
              this.state.selectedProducts.length > 0 ?
              this.state.selectedProducts.map(({ name = '', id = '' }, i) => {
                return (
                  <div
                    key={id}
                    data-test="selected-item"
                    className="gdl-selected-item"
                  >
                    <p> {name} </p>
                    <button
                      className="gdl-close-btn"
                      data-test={`gdl-close-btn-${i}`}
                      onClick={() => this.deleteSelectedProduct(id)}>
                      <CloseIcon />
                    </button>
                  </div>
                );
              })
              : ""}
        </div>
        <div
          ref={this.inputwrap}
          className="input-group uxf-search"
        >
          <div
            className="input-group uxf-search test-input"
            data-test="test-input"
          >
            <input
              data-test="product-level-search"
              ref={this.inputref}
              onKeyUp={this.customAutocomplete}
              id="product-level-search"
              aria-label="Search"
              className="uxf-search-bar form-control"
              type="search"
              placeholder={GDL_SEARCH_PRODUCTs_EX_MOVER} name="s"
            />
            <div className="input-group-append">
              <button
                className="gdl-close-btn gdl-reset-btn"
                data-test='gdl-reset-btn'
                onClick={this.reset}>
                <CloseIcon />
              </button>

            </div>
            <br />
            <BodyEnd>
              <div
                style={styles}
                id="display-autocomplete"
                className={this.state.suggest && this.state.suggest.length > 0 ?
                  "display-autocomplete" : "hidden"
                }
              >

                {
                  this.state.suggest ?
                    this.state.suggest.map(({ name = '', id = '' }, i) => {
                      return (
                        <div key={id}
                          className="gdlItem gdlItem-select"
                          data-gdl-item={`gdlItem-${i}`}
                          data-gdl-item-click={`gdlItem`}
                          data-test={`gdlItem-select-${i}`}
                          onClick={
                            () => this.selecteProduct({ name: name, id: id })
                          }>
                          {name}
                        </div>
                      );
                    })
                    : ""}
              </div>
            </BodyEnd>
          </div>
        </div>
      </div>
    );
  }
}

ProductSearch.propTypes = {
  selectEquipment: func,
  productgroups: array,
  translate: shape({
    GDL_SEARCH_PRODUCTs_EX_MOVER: string,
    GDL_EQUIPMENT: string,
    GDL_NO_PRODUCT_SELECTED: string,
  })
};
export default ProductSearch;